import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { capabilitiesOf, shownOnly } from "../../utils/analyticsCapabilities";
import { highlights } from "../../utils/analyticsHighlights";
import EvolutionCard, { OVERVIEW_METRICS } from "./EvolutionCard";
import FunnelSteps from "./FunnelSteps";
import HighlightCards from "./HighlightCards";
import KpiPanel from "./KpiPanel";

// A visao geral (spec do redesign, R4): os numeros principais (quatro, ou tres sem operadores), os
// destaques, o funil e a evolucao. O ultimo dia so fica a tracejado quando o periodo acaba hoje (um periodo
// a escolha; os predefinidos acabam ontem).
// `previousComplete` vem da pagina: sem ele as variacoes dizem "sem comparacao" e a variacao das conversas
// nao acende.
const OverviewTab = ({ summary, firstQuestions, period, today, previousComplete, onGo }) => {
  const { translate } = useLanguage();
  const items = highlights({ summary, firstQuestions, viewerZone: period.tz, previousComplete });
  return (
    <div className="space-y-6">
      <KpiPanel summary={summary} previousComplete={previousComplete} />
      {items.length > 0 && <HighlightCards items={items} onGo={onGo} />}
      <FunnelSteps funnel={summary.funnel} />
      <EvolutionCard
        series={summary.series}
        metrics={shownOnly(OVERVIEW_METRICS, capabilitiesOf(summary))}
        title={translate("analyticsEvolution")}
        anchorId="analytics-evolution"
        partialLast={period.to === today}
        previousComplete={previousComplete}
        cut={summary.cut}
        timeZone={period.tz}
      />
    </div>
  );
};

export default OverviewTab;
